import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../constants/data';

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-3">
              <i className="bi bi-truck me-2"></i>{companyInfo.name}
            </h5>
            <p className="text-light">Professional forklift services, rentals, and spare parts solutions for all industrial needs.</p>
            <div className="mt-3">
              <p className="mb-1"><i className="bi bi-geo-alt me-2"></i>{companyInfo.address}</p>
              <p className="mb-1"><i className="bi bi-receipt me-2"></i>{companyInfo.gst}</p>
            </div>
          </div>
          
          <div className="col-md-2 mb-4">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-light text-decoration-none">Home</Link></li>
              <li className="mb-2"><Link to="/about" className="text-light text-decoration-none">Know Us</Link></li>
              <li className="mb-2"><Link to="/services" className="text-light text-decoration-none">Services</Link></li>
              <li className="mb-2"><Link to="/contact" className="text-light text-decoration-none">Contact</Link></li>
            </ul>
          </div>
          
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Our Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><i className="bi bi-check-circle me-2 text-primary"></i>Forklift Rentals</li>
              <li className="mb-2"><i className="bi bi-check-circle me-2 text-primary"></i>Spare Parts</li>
              <li className="mb-2"><i className="bi bi-check-circle me-2 text-primary"></i>Maintenance</li>
              <li className="mb-2"><i className="bi bi-check-circle me-2 text-primary"></i>Operator Training</li>
            </ul>
          </div>
          
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Contact Info</h5>
            <ul className="list-unstyled">
              <li className="mb-2"><i className="bi bi-telephone me-2"></i>{companyInfo.phone}</li>
              <li className="mb-2"><i className="bi bi-envelope me-2"></i>{companyInfo.email}</li>
              <li className="mb-2"><i className="bi bi-clock me-2"></i>{companyInfo.workingHours}</li>
            </ul>
            <div className="mt-3">
              <a href={`tel:${companyInfo.phone}`} className="btn btn-primary btn-sm me-2">
                <i className="bi bi-telephone"></i> Call Now
              </a>
              <a href={`mailto:${companyInfo.email}`} className="btn btn-outline-light btn-sm">
                <i className="bi bi-envelope"></i> Email
              </a>
            </div>
          </div>
        </div>
        
        <hr className="bg-light my-4" />
        
        <div className="row">
          <div className="col-md-6 text-center text-md-start">
            <p className="mb-0">&copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p className="mb-0">Designed for industrial excellence</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;